import React, {Fragment, useEffect, useReducer, useState} from 'react';
import PropTypes from "prop-types";
//var bootbox = require('bootbox');
import ModalContentWrapper from '../ModalContentWrapper';
import {useForm} from "react-hook-form";
import FormToggle from "root/ReactHookForm/ControlWrappers/FomToggle";
import ErrorDiv from "root/ReactHookForm/ui/ErrorDiv";
import {getTeamDetails, createTeam, updateTeam, deleteTeam} from "root/DataFunctions/TeamDataFns";
import {getDataFromResponse} from "root/DataFunctions/BaseDataFns";
import SpinnerDiv from "root/Components/SpinnerDiv";

const ModalAddTeam = (props) =>
{
    const [ buttonState, setButtonState ] = useState ('') ;
    const [data, setData] = useState({ isLoading: false, data: [] });

    const {register, control, handleSubmit, setFocus, watch, setValue, formState: {errors: formErrors}} = useForm(
        {
            defaultValues: {
                team: {
                    team_name: '',
                    team_desc: '',
                    letterbox_team: false
                }
            }
        });

    const isFetchRequired = props.mode === 'edit' || props.mode === 'view' || props.mode === 'delete' ;

    const titles = {
        view: 'View Team Details',
        edit: 'Edit Team Details',
        create: 'New Team',
        delete: 'Delete Team'
    } ;

    const saveButtonText = {
        view: 'Close',
        edit: 'Save Changes',
        create: 'Save',
        delete: 'Click To Delete'
    } ;

    useEffect(() =>
    {
        if ( isFetchRequired )
        {
            getTeamDetails(props.team_id, (response) =>
            {
                const teamData = getDataFromResponse(response)[0] ;
                const is_letterbox_team = +teamData.letterbox_team === 0 ? false : true;

                setValue('team', {
                    team_name: teamData.team_name,
                    team_desc: teamData.team_desc,
                    letterbox_team: is_letterbox_team
                    }
                );

                setData({isLoading: false, data: teamData});
            });
        }
    }, []);

    const onSaveComplete = () =>
    {
        props.onSaveCompleted ('saved');
        props.onClose() ;
    }

    const onClickCancel = () =>
    {
        props.onSaveCompleted ('cancel');
        props.onClose() ;
    }

    const doSaveNew = ( data ) =>
    {
        const organisation_id = props.organisation_id !== undefined ? props.organisation_id : null;
        createTeam(data.team, organisation_id, onSaveComplete ) ;
    }

    const doSave = (data) =>
    {
        updateTeam(props.team_id, data.team, onSaveComplete ) ;
    }

    const doDelete = ( onComplete ) =>
    {
        deleteTeam( props.team_id, onSaveComplete ) ;
    }

    const onClickSave = (status) =>
    {
        handleSubmit(onSubmit)(status);
    }

    const onSubmit = (data) =>
    {
        disableButtons();

        switch (props.mode)
        {
            case 'create' :
                doSaveNew(data, onSaveComplete);
                break;
            case 'edit' :
                doSave(data, onSaveComplete);
                break;
            case 'delete' :
                bootbox.confirm({
                    size: "small",
                    message: "Are you sure you want to delete this team?",
                    callback: (result =>
                    {
                        if (result)
                        {
                            doDelete();
                        }
                    })
                })
                break;
        }
    }

    const disableButtons = () =>
    {
        setButtonState ('disabled');
    }

    const Title = ( props ) =>
    {
        return <h3>{titles[props.mode]}</h3>
    }

    const getSaveButtonText = ( mode ) =>
    {
        return saveButtonText[props.mode] ;
    }

    const getSaveButtonStyle= ( mode ) =>
    {
        switch ( mode )
        {
            case 'delete':
                return "btn btn-icon btn-danger btn-icon-right btn-small" ;
            default:
                return "btn btn-icon btn-primary btn-icon-right btn-small" ;
        }
    }

    const SaveButton = (props) =>
    {
        const clickHandler = buttonState === '' ? onClickSave : null;

        return (
            <button onClick={clickHandler} style={{marginRight: '10px', marginLeft: '10px'}} disabled={buttonState} className={getSaveButtonStyle(props.mode)}>{getSaveButtonText(props.mode)}<i className="et-save" /></button>
        )
    }

    const formContent = () =>
    {
        if ( data.isLoading === true )
        {
            return (
                <div style={{width: props.width}}>
                    <SpinnerDiv />
                </div>
            )
        }
        else
        {
            const isReadOnly = props.mode === 'view' || props.mode === 'delete' ;

            return (
                <Fragment>
                    <div className='buy-card-right'>
                        <form className='registration-form' onSubmit={handleSubmit(onSubmit)}>
                            <div className='row'>
                                <div className='col-md-6'>
                                    <div style={{marginBottom: '10px'}}>
                                        <label>Team Name</label>
                                        <input readOnly={isReadOnly} className='form-control' name='team.team_name'
                                               id='title' {...register("team.team_name")} />
                                        {formErrors.team?.team_name && <ErrorDiv>Please enter a name</ErrorDiv>}
                                    </div>
                                </div>

                                <div className='col-md-6'>
                                    <div style={{marginBottom: '20px'}}>
                                        <label>Team Description</label>
                                        <input readOnly={isReadOnly} className='form-control' name='team.team_desc'
                                               id='description' {...register("team.team_desc")} />
                                        {formErrors.team?.team_desc && <ErrorDiv>Please enter a description</ErrorDiv>}
                                    </div>
                                </div>
                            </div>

                            <div className='slider-group' style={{marginBottom: '20px'}}>
                                <label>Is Letterbox Team</label>
                                <FormToggle readOnly={isReadOnly} control={control} name='team.letterbox_team'/>
                            </div>
                        </form>
                    </div>

                    <div className="d-flex flex-row justify-content-end">
                        <button onClick={onClickCancel} className="btn btn-secondary">Cancel<i className="et-arrow-bold-left"/></button>
                        <SaveButton mode={props.mode} onClick={onClickSave} />
                    </div>
                </Fragment>
            )
        }
    }

    return (
        <ModalContentWrapper className="modal-wrapper" width={'600px'} columns={2}>
            <Title mode={props.mode} />
            {formContent()}
        </ModalContentWrapper>
    )
}

export default ModalAddTeam;

ModalAddTeam.defaultProps =
{
    width: '600px',
    height:'800px'
}

ModalAddTeam.propTypes = {
    team_id: PropTypes.string,
    width: PropTypes.string,
    mode: PropTypes.string.isRequired,
    onSaveCompleted: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired
};
